import { useEffect } from 'react';

// Section ids that changed in the thought-leadership redesign; old shared links still land correctly.
const LEGACY_SECTION_IDS: Record<string, string> = {
  publications: 'writing',
  certifications: 'expertise',
  professional: 'expertise',
  books: 'reading-list',
  personal: 'beyond-work',
};

export const resolveSectionId = (hash: string): string => {
  const id = hash.replace(/^#/, '');
  return LEGACY_SECTION_IDS[id] ?? id;
};

/**
 * Sections render after the browser's own hash scroll has already run, so scroll to the
 * hash target (mapping legacy ids) once the page has mounted.
 */
export const useLegacyHashScroll = (): void => {
  useEffect(() => {
    if (!window.location.hash) return;
    const targetId = resolveSectionId(window.location.hash);
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(targetId)?.scrollIntoView();
    });
    return () => window.cancelAnimationFrame(frame);
  }, []);
};
